import { createContext } from 'react';

/**
 * True below a mounted `RecaptchaProvider`. Ours because the library's context cannot answer it: outside
 * its provider `executeRecaptcha` is a throwing default function, inside it is `undefined` until the
 * script loads.
 */
export const RecaptchaContext = createContext(false);
